module.exports = __webpack_public_path__ + "static/media/Portrait-10224.d6109001.jpg";